import React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { PALETTE } from '~/assets/styles/base';

const Wrapper = styled(Box)`
  width: 100%;
  background: #faeaea 0% 0% no-repeat padding-box;
  border: none;
  hr {
    border: 1px solid ${PALETTE.text.main};
    opacity: 1;
  }
`;

const StyledBox = styled(Box)`
  padding: 10px;
  display: flex;
  align-items: center;
  word-break: break-all;
`;

const RejectedReasonBoxLabel = styled(Box)`
  width: 70px;
  min-width: 70px;
  text-align: center;
`;

const RejectedReasonBoxContent = styled(Box)`
  padding: 10px;
  flex-grow: 1;
`;

type Props = {
  reasonText: string;
};

const RejectedReasonBox: React.FC<Props> = ({ reasonText }): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <StyledBox data-testid="uiParts-RejectedReasonBox">
        <RejectedReasonBoxLabel data-testid="uiParts-RejectedReasonBox-lbl">
          <Typography variant="h6" component="span">
            {t('myPage.reason')}
          </Typography>
        </RejectedReasonBoxLabel>
        <Divider orientation="vertical" variant="middle" flexItem />
        <RejectedReasonBoxContent data-testid="uiParts-RejectedReasonBox-cnt">
          <Typography
            variant="h5"
            component="span"
            sx={{
              whiteSpace: 'pre-line',
            }}
            data-testid="uiParts-RejectedReasonBox-cnt-Typography"
          >
            {reasonText}
          </Typography>
        </RejectedReasonBoxContent>
      </StyledBox>
    </Wrapper>
  );
};

export default RejectedReasonBox;
